import { Controller } from "@hotwired/stimulus";
import { dispatchFilterUpdatedEvent } from "../../datatables/datatable_filters";

export default class extends Controller {
  static targets = ["radioInput"];
  static outlets = ["datatables--selected-filter"];

  connect() {
    if (this.hasDatatablesSelectedFilterOutlet) {
      this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
    }
  }

  filterChanged() {
    this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
    this._filterUpdated();
  }

  _filterUpdated() {
    const { filterName } = this.element.dataset;

    dispatchFilterUpdatedEvent({ name: filterName });
  }

  _translatedValue() {
    const selectedRadio = this.radioInputTargets.find((radio) => radio.checked);
    return selectedRadio?.dataset?.translatedValue;
  }
}
